RivalIQ.apps.Overview.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.MetaTable = Marionette.ItemView.extend({
        template: '#overviewMetaTableTemplate',
        serializeData: function () {

            const me = this;
            const config = me.options.config;

            const value = me.options.companyData.compareData.getValue(
                config.metric,
                RivalIQ.enums.valueType.CURRENT,
                null,
                RivalIQ.state.utils.getFocusedCompanyId()
            ).value;

            return {
                title: config.title,
                value: value
            };
        }
    });
});
